function resolveChildTextLabels(childTextLabels = [], allLabels = []) {
  if (!Array.isArray(childTextLabels)) {
    return [];
  }

  return childTextLabels
    .map((childLabel) => {
      if (childLabel && typeof childLabel === "object") {
        return childLabel;
      }

      return allLabels.find((label) => label.id === childLabel);
    })
    .filter((label) => label !== undefined);
}

function getStaticImageLabelVisibilityStatus({ visible, childTextLabels = [], allLabels = [] }) {
  const resolvedChildTextLabels = resolveChildTextLabels(childTextLabels, allLabels);

  if (resolvedChildTextLabels.length === 0) {
    return visible ? "all" : "none";
  }

  const visibleChildTextLabelCount = resolvedChildTextLabels.filter((childLabel) => childLabel.visible !== false).length;

  if (visibleChildTextLabelCount === 0) {
    return "none";
  }

  if (visibleChildTextLabelCount === resolvedChildTextLabels.length) {
    return "all";
  }

  return "mixed";
}

function getStaticImageLabelVisibilityIcon(status) {
  switch (status) {
    case "all":
      return "check_box";
    case "mixed":
      return "indeterminate_check_box";
    case "none":
    default:
      return "check_box_outline_blank";
  }
}

function getStaticImageLabelVisibilityTitle(status) {
  switch (status) {
    case "mixed":
      return "Some image text labels are hidden";
    case "all":
      return "Toggle Visible";
    case "none":
    default:
      return "Toggle Visible";
  }
}

export { resolveChildTextLabels, getStaticImageLabelVisibilityStatus, getStaticImageLabelVisibilityIcon, getStaticImageLabelVisibilityTitle };
